// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2kjb5","inner":"Footer_inner__1k5zb"};